import React, { useState } from "react";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <div style={{
      position: "fixed",
      bottom: "25px",
      right: "25px",
      zIndex: 9999
    }}>
      {open && (
        <div
          style={{
            background: "#fff",
            width: "260px",
            borderRadius: "15px",
            padding: "15px",
            marginBottom: "15px",
            boxShadow: "0 10px 25px rgba(0,0,0,.2)"
          }}
        >
          <h3 style={{ marginTop: 0 }}>Contact HIG Automation</h3>

          <a
            href="https://wa.me/919896314582?text=Hello%20HIG%20Automation,%20I%20am%20interested%20in%20your%20Automation%20Solutions."
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block", marginBottom: "12px", textDecoration: "none" }}
          >
            🟢 WhatsApp
          </a>

          <a
            href="tel:+919896314582"
            style={{ display: "block", marginBottom: "12px", textDecoration: "none" }}
          >
            📞 Call Us
          </a>

          <a
            href="mailto:info@higautomation.com"
            style={{ display: "block", textDecoration: "none" }}
          >
            ✉️ Email Us
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          background: "#25D366",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          fontSize: "26px",
          boxShadow: "0 5px 20px rgba(0,0,0,.3)"
        }}
      >
        💬
      </button>
    </div>
  );
}